"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuid = uuid;
exports.random = random;
exports.batchExecSync = batchExecSync;
exports.batchExecAsync = batchExecAsync;
exports.isPluginExtended = isPluginExtended;
exports.isPluginInstance = isPluginInstance;
exports.logger = exports.timestamp = void 0;

var _const = require("./const");

// util methods
// @author Pluto <huarse@gmail.com>
// @create 2019/12/30 14:24
const SHOW_LOG = /(\d+\.)|daily|test|local|debug|mock|(\d{4,5})/.test(location.origin) || /debug/.test(location.search) || window.DEBUG || window.IS_DEBUG;
const LOGGER_TYPES = [{
  color: '#9b9ea0',
  type: 'DEBUG',
  valid: SHOW_LOG
}, {
  color: '#f15533',
  type: 'ERROR',
  valid: true
}, {
  color: '#ff8a00',
  type: 'WARN',
  valid: true
}, {
  color: 'magenta',
  type: 'LINE',
  valid: SHOW_LOG
}, {
  color: '#00c1de',
  type: 'INFO',
  valid: SHOW_LOG
}, {
  color: '#35b34a',
  type: 'SUCCESS',
  valid: SHOW_LOG
}];

const numFmt = n => n > 9 ? "".concat(n) : "0".concat(n);

const timestamp = () => {
  const d = new Date();
  return "".concat(numFmt(d.getHours()), ":").concat(numFmt(d.getMinutes()), ":").concat(numFmt(d.getSeconds()), ".").concat(d.getMilliseconds());
};

exports.timestamp = timestamp;

const logger = function () {
  const _factory = ({
    type,
    color,
    valid
  }) => (...args) => {
    const prefix = typeof args[0] === 'string' ? args.shift() : ''; // eslint-disable-next-line

    valid && console.log("%c%s%c\u3010".concat(type, "\u3011").concat(prefix), 'color:#999', timestamp(), "color:".concat(color), ...args);
  };

  return LOGGER_TYPES.reduce((prev, item) => {
    return prev[item.type.toLowerCase()] = _factory(item), prev;
  }, {});
}();
/**
 * 创建一个uuid
 * @return {string}
 */


exports.logger = logger;

function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16).toUpperCase();
  });
}
/**
 * Return a random integer of [min, max] (inclusive min and max)
 * @param {number} min
 * @param {number} [max]
 * @return {number}
 */


function random(min, max) {
  if (max === undefined) {
    max = min;
    min = 0;
  } // Math.random() -> [0, 1)


  return min + Math.floor(Math.random() * (max - min + 1));
}
/**
 * 批量执行同步方法
 * @param {Function[]} callbacks
 * @param {any[]} [args]
 * @param {any} [scope]
 */


function batchExecSync(callbacks, args, scope) {
  return callbacks.map(callback => {
    try {
      const result = callback.apply(scope, args || []);
      return {
        success: true,
        result
      };
    } catch (error) {
      logger.warn('ERROR in exec callback', error);
      return {
        success: false,
        error
      };
    }
  });
}
/**
 * 批量执行异步方法
 * @param {Function[]} callbacks
 * @param {any[]} args
 * @param {Promise<Array>} scope
 */


function batchExecAsync(callbacks, args, scope) {
  const promises = callbacks.map(async callback => {
    try {
      const result = await callback.apply(scope, args || []);
      return {
        success: true,
        result
      };
    } catch (error) {
      logger.warn('ERROR in exec callback', error);
      return {
        success: false,
        error
      };
    }
  });
  return Promise.all(promises);
}
/** 是否是 Plugin 继承类 */


function isPluginExtended(clazz) {
  while (clazz = Object.getPrototypeOf(clazz)) {
    if (!clazz || clazz === Function.prototype) return false;
    if (clazz[_const.CLASS_SYMBOL] === _const.PLUGIN_CLASS) return true;
  }

  return false;
}
/** 是否是 Plugin 继承类的实例 */


function isPluginInstance(ins) {
  let clazz = Object.getPrototypeOf(ins).constructor;

  while (clazz = Object.getPrototypeOf(clazz)) {
    if (!clazz || clazz === Function.prototype) return false;
    if (clazz[_const.CLASS_SYMBOL] === _const.PLUGIN_CLASS) return true;
  }

  return false;
}